export default __webpack_public_path__ + "static/media/Cyclope-1-Yellow-24x24.6f86edbf.svg";